module.exports = {
      id: "pak-flag-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#pak-flag",
      toString: function () {
        return this.url;
      }
    }